//import { gsap } from "gsap";
import * as feedback from "./feedback";
import * as feedbackv2 from "./feedbackv2";

class Pages {
    constructor() {
    }

    in(page) {
        console.log('Pages.in()', page);

        let functionName = page +'In';
        console.log(functionName, typeof this[functionName]);

        if (typeof this[functionName] === 'function') {
            this[functionName]();
        }
    }

    out(page) {
        console.log('Pages.out()', page);
        let promiseTime = 0;

        let functionName = page +'Out';
        if (typeof this[functionName] === 'function') {

            $('#page-'+ page +' *, #footer, #footer *' ).css('animation-delay', '0s');


            promiseTime = this[functionName]();
        }

        promiseTime = promiseTime * timeMultiplier;

        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, promiseTime);
        });
    }

    homeIn() {

    }

    homeOut() {
        $('#page-home img, #footer .button').addClass('fade-out');
        this.hideTermsLinks();
        return fadeSpeed;
    }

    indexOut() {
        $('#page-index').addClass('fade-out');
        this.hideTermsLinks();
        return fadeSpeed;
    }

    warningOut() {
        $('#page-warning').addClass('fade-out');
        return fadeSpeed;
    }

    startIn() {
        $('#footer .button').click(() => {
            $('#page-start form').trigger('submit');
        });
        $('#page-start form').submit(() => {
            $('#footer .button .text').html('Loading<span class="dots"></span>');
            setTimeout(() => {
                $('#footer .button .inner').css('opacity', 0.3);
            }, hoverSpeed);
        });
    }

    startOut() {
        $('#page-start, #footer .button').addClass('fade-out-slow');
        this.hideTermsLinks();
        return fadeSlowSpeed;
    }

    selectIn() {
        $('.character').removeClass('selected')
            .removeClass('fade-out')
            .removeClass('fade-out-slower');
        $('.character').click(function() {
            if ($('.character').attr('disabled')) {
                return false;
            }

            $(this).removeClass('fade-in');
            $(this).removeClass('fade-delay1');
            $(this).removeClass('fade-delay2');
            $(this).removeClass('fade-delay3');
            $(this).removeClass('fade-delay4');

            $(this).addClass('selected');
            $(this).addClass('fade-out-slower');
        });
    }

    selectOut() {
        $('.character').attr('disabled', true);
        $('.character:not(.selected), h2').addClass('fade-out');
        console.log('fadeSlowerSpeed', fadeSlowerSpeed);
        return fadeSlowerSpeed;
    }
    typeOut() {
        $('.modes a, h2').addClass('fade-out');
        return fadeSlowSpeed;
    }

    hideTermsLinks() {
        console.log('hideTermsLinks()');
        if (lastLinkNotes == 'hide-terms') {
            $('.terms-links').addClass('fade-out-slow');
        }
    }

    reflectIn() {
        let mp3Reflection = new Audio();
        mp3Reflection.volume = 1;
        mp3Reflection.src = asset_base+'sounds/reflection.mp3';
        mp3Reflection.play();
    }

    reflectOut() {
        $('.reflection').addClass('fade-out');
        return fadeSpeed;
    }

    feedbackIn() {
        feedback.feedbackIn(this);
    }

    feedbackOut() {
        $('#FEEDBACK, feedback-footer').addClass('fade-out');
        return fadeSpeed;
    }

    feedbackv2In() {
        console.log('EEERE');
        feedbackv2.feedbackv2In(this);
    }

    feedbackv2Out() {
        $('#FEEDBACKV2, feedback-footer').addClass('fade-out');
        return fadeSpeed;
    }
}

export default Pages;
